<template>
    <div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="职责权限" name="roleTpl"></el-tab-pane>
            <el-tab-pane label="岗位" name="role"></el-tab-pane>
        </el-tabs>

        <div class="table-layout" v-if="activeName == 'roleTpl'">
            <el-table :data="merchtTplRoleList" border style="width: 100%">
                <el-table-column width="150" prop="confName" label="职责权限名称"></el-table-column>
                <el-table-column width="150" prop="realName" label="目标岗位名称"></el-table-column>
                <el-table-column prop="mobAppRoleName" label="移动端角色" width="80"></el-table-column>
                <el-table-column width="140" prop="shopFlag" align="center" label="是否门店专用">
                    <template slot-scope="rows">
                        <span>{{rows.row.shopFlag ? '是' : '否'}}</span>
                    </template>
                </el-table-column>
                <el-table-column width="100" prop="comLevel" label="适用级别" align="center" show-overflow-tooltip>
                    <template slot-scope="rows" v-if="!rows.row.shopFlag">
                        <span v-if="rows.row.comLevel1">一级业务单元</span>
                        <span v-if="rows.row.comLevel2"><span v-if="rows.row.comLevel1">，</span>二级业务单元</span>
                        <span v-if="rows.row.comLevel3"><span v-if="rows.row.comLevel1 || rows.row.comLevel2">，</span>三级业务单元</span>
                        <span v-if="rows.row.comLevel4"><span v-if="rows.row.comLevel1 || rows.row.comLevel2 || rows.row.comLevel3">，</span>四级业务单元</span>
                    </template>
                </el-table-column>
                <el-table-column width="140" prop="bizPermFlag" align="center" label="业务权限限制">
                    <template slot-scope="rows">
                        <span>{{rows.row.bizPermFlag ? '启用' : '关闭'}}</span>
                    </template>
                </el-table-column>
                <el-table-column width="120" prop="bizPermOrgFlag" label="业务权限模式">
                    <template slot-scope="rows">
                        <span>{{bizPermOrgFlagEnumMap[rows.row.bizPermOrgFlag]}}</span>
                    </template>
                </el-table-column>
                <el-table-column width="120" prop="bizPermScopName" label="业务范围"></el-table-column>
                <el-table-column prop="desc" label="描述" show-overflow-tooltip></el-table-column>
                <el-table-column prop="id" label="操作" align="left" width="200">
                    <template slot-scope="rows">
                        <div class="swb-btn swb-btn-link" @click="syncSubscrMsgForRolTpl(rows.row.id, true)">覆盖订阅</div>
                        <div class="swb-btn swb-btn-link" @click="syncSubscrMsgForRolTpl(rows.row.id, false)">追加订阅</div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-layout">
                <el-pagination background v-if="totalCount > 0" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="prev, pager, next, jumper, sizes, total"></el-pagination>
            </div>
        </div>

        <div class="column-layout clearfix" v-else>
            <div class="left-column fl" :class="{'active' : !treeCollapse}">
                <div class="tab-container base">
                    <div class="tabs-nav">
                        <ul class="head">
                            <li class="head-item current">组织机构</li>
                        </ul>
                    </div>
                </div>
                <div id="tree-menu" style="overflow-y: auto;">
                    <swb-org-tree :searchSize="'mini'" :enableSearch="true" @notity-change="notityChange($event)" @show-tree-collapse="showTreeCollapse($event)"></swb-org-tree>
                </div>
            </div>
            <div class="right-column fl">
                <div class="mt10 mb10">
                    <label>岗位：</label>
                    <el-select v-model="thisRoleId" @change="thisRoleIdChange">
                        <el-option v-for="item in roleList" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                    <div class="swb-btn swb-btn-mini fr" @click="syncSubscrMsgForStaff(true)">覆盖订阅</div>
                    <div class="swb-btn swb-btn-mini fr mr5" @click="syncSubscrMsgForStaff(false)">追加订阅</div>
                </div>
                <div class="table-layout">
                    <el-table :data="staffList" border style="width: 100%" @selection-change="handleSelectionChange">
                        <el-table-column type="selection" width="40" align="center"></el-table-column>
                        <el-table-column align="left" width="130" prop="name" label="员工姓名"></el-table-column>
                        <el-table-column align="center" width="130" prop="contactTel" label="联系电话"></el-table-column>
                        <el-table-column align="center" width="180" prop="contactEmail" label="联系邮箱"></el-table-column>
                        <el-table-column align="center" width="80" prop="osFlag" label="是否外协">
                            <template slot-scope="rows">
                                <span class="font-green" v-if="rows.row.osFlag">是</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" width="80" prop="csFlag" label="是否客服">
                            <template slot-scope="rows">
                                <span class="font-green" v-if="rows.row.csFlag">是</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" width="100" prop="enrollDate" label="入职日期"></el-table-column>
                        <el-table-column align="center" width="100" prop="quitDate" label="离职日期"></el-table-column>
                        <el-table-column align="center" width="80" prop="disabled" label="是否禁用">
                            <template slot-scope="rows">
                                <span class="font-red" v-if="rows.row.disabled">是</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="disabledCause" label="禁用描述" show-overflow-tooltip></el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import { getDefaultPageSizes } from '../../app.conf'

    import retailerApi from '../../api/retailer'
    import retailerAuthxApi from '../../api/retailerAuthx'
    import userApi from '../../api/user'
    import merchtAll from '../../api/merchtAll'
    import merchtAllApi from '../../api/merchtAll'
    import bizMsgApi from '../../api/bizMsg'

    export default {
        name: 'swb-biz-event-msg-subscr-tpl-set-staff',
        desc: '员工订阅消息模版',
        props: ['shopFlag', 'tplId'],
        data: function () {
            return {
                treeCollapse: true,
                staffList: [],
                roleList: [],
                comInfo: {},
                thisComId: null,
                thisRoleId: null,
                multipleSelection: [],
                //
                activeName: "roleTpl",
                merchtTplRoleList: [],
                bizPermOrgFlagEnumMap: {},
                // 分页信息
                pageNumber: 1,
                totalCount: 0,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
            }
        },
        created: function () {
            this.pageSize = this.pageSizes.first();
            this.getUserInfoByContext();
            //
            this.getMerchtTplRoleList();
            this.bizPermOrgFlagEnumMap = getEnumMap("bizPermOrgFlag", "value2text");
        },
        methods: {
            handleClick: function (tab, event) {
//                let activeName = this.activeName;
//                if(activeName == 'roleTpl') {
//                    this.activeName = "role";
//                }
            },
            showTreeCollapse: function (treeCollapse) {
                this.treeCollapse = treeCollapse;
            },
            notityChange(eventData) {
                let self = this;
                if(this.thisComId != eventData.id) {
                    this.thisComId = eventData.id;
                    this.getComDetail(function () {
                        if(self.shopFlag && !self.comInfo.shopFlag) {
                            self.thisRoleId = null;
                            self.roleList = [];
                            //
                            self.staffList = [];
                            Toast.show("当前选择的消息订阅模版是门店专用,【" + self.comInfo.name + "】不是门店");
                        } else {
                            self.getComRoleList();
                        }
                    });
                }
            },
            getUserInfoByContext() {
                let self = this;
                userApi.getUserInfoByContext({}, function (result) {
                    if(result.type == "info") {
                        self.userContext = result.data;
                        self.notityChange({
                            id: self.userContext.scopeEntity.comId
                        });
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 获取部门岗位
            getComRoleList(){
                let self = this;
                let postData = {};
                postData.bizUnitId = this.thisComId;
                let theLoading = MsgBox.loading();
                retailerAuthxApi.getRetailerComRoleList(postData, function (result) {
                    theLoading.close();
                    if(result.type === "info") {
                        let roleList = result.data;
                        if(roleList.length > 0) {
                            self.thisRoleId = roleList[0].id;
                            //
                            self.getStaffList();
                        } else {
                            self.thisRoleId = null;
                        }
                        self.roleList = Utils.merge([], roleList);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            thisRoleIdChange(){
                if(this.thisRoleId != null) {
                    this.getStaffList();
                } else {
                    this.staffList = [];
                }
            },
            getStaffList(){
                let self = this;
                let postData = {
                    roleId: this.thisRoleId
                };
                let theLoading = MsgBox.loading();
                merchtAll.getMerchantStaffListByRoleIdAndMerchantType(postData, function (result) {
                    theLoading.close();
                    if(result.type === "info") {
                        self.staffList = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getComDetail(callback) {
                let self = this;
                let postData = {
                    comId: this.thisComId
                };
                let theLoading = MsgBox.loading();
                retailerApi.getRetailerCom(postData, function (result) {
                    theLoading.close();
                    if(result.type == 'info') {
                        self.comInfo = result.data;
                        callback();
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 勾选事件
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            syncSubscrMsgForStaff(covered){
                let self = this;
                let staffIds = self.multipleSelection.pluck("id");
                if(staffIds != null && staffIds.length <= 0) {
                    MsgBox.warning("请勾选要订阅的员工");
                    return;
                }
                let title = covered ? '覆盖订阅' : '追加订阅';
                this.$confirm('确定要【' + title + '】吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let postData = {};
                    postData.tplId = self.tplId;
                    postData.staffIds = staffIds;
                    postData.covered = covered;
                    let theLoading = MsgBox.loading();
                    bizMsgApi.doBizEventMsgSubscrTplSetStaff(postData, function (result) {
                        theLoading.close();
                        if(result.type === "info") {
                            MsgBox.success("操作成功！");
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {
                });
            },
            // ----------------------------- 模板岗位相关 ---------------------------
            //
            handleSizeChange: function (val) {
                this.pageSize = val;
                this.handlePageChange(1);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.getMerchtTplRoleList();
            },
            getMerchtTplRoleList(){
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                let filterItems = {};
                filterItems.shopFlag = self.shopFlag;
                //
                postData.filterItems = filterItems;
                //
                let theLoading = MsgBox.loading();
                merchtAllApi.getMerchtTplRoleList(postData, function (result) {
                    theLoading.close();
                    if(result.type == 'info') {
                        self.merchtTplRoleList = result.data.rows;
                        //
                        self.totalCount = result.data.pagination.totalCount;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 模板岗位-同步订阅消息
            syncSubscrMsgForRolTpl: function (merchtTplRoleId, covered) {
                let self = this;
                let title = covered ? '覆盖订阅' : '追加订阅';
                this.$confirm('确定要【' + title + '】吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let postData = {};
                    postData.merchtTplRoleId = merchtTplRoleId;
                    postData.covered = covered;     // 是否覆盖更新
                    postData.bizMsgId = self.tplId;
                    //
                    let theLoad = MsgBox.loading();
                    bizMsgApi.doSyncBizEventMsgSubscrTpl(postData, function (result) {
                        theLoad.hide();
                        if(result.type == 'info') {
                            //
                            MsgBox.success("操作成功！");
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {
                });
            }

        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/bizMsg/BizEventMsgSubscrTplSetStaff.vue